import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '@app/services';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: false
})
export class NotFoundComponent {
  fromDocumentUrl: string;

  constructor(
    private router: Router,
    public appService: AppService
  ) {
    this.fromDocumentUrl = (router.getCurrentNavigation().extras.state || {}).fromDocumentUrl;
  }

  obscureUrl(url: string) {
    let cleanUrl = (url || '').split('?')[0];
    if (/\/(assinar|sign)\/([A-z0-9]{40})/.test(cleanUrl)) {
      // Only obscure private signature URLs
      return cleanUrl.replace(/([A-z0-9]{8})$/, '********');
    }
    return cleanUrl;
  }
}
